module.exports = __webpack_public_path__ + "static/img/template-board-rec.fdc2222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/templates/template-board-rec.png
// module id = j6kr
// module chunks = 1